import styled from 'styled-components';

export const MenuPickerBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;

  @media (max-width: 800px) {
    margin-top: 16px;
    gap: 8px;
  }
`;

/* The select takes the row on a phone and a comfortable column on desktop;
   min-width: 0 lets a long menu name truncate instead of widening it. */
export const MenuSelectWrap = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 420px;

  @media (max-width: 800px) {
    max-width: none;
  }
`;

/* A menu name is up to 100 characters; the select shows one line of it and
   cuts the rest with an ellipsis. The pill and the icons next to it are
   flex: none so the name is what gives way. */
export const MenuName = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ProviderIconRow = styled.span`
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  line-height: 0;
  vertical-align: middle;

  img {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    object-fit: cover;
  }
`;

/* PlusIcon draws itself at 32px; as an option icon it has to match the
   18px unpublished dot next to the other options. */
export const NewMenuOptionPlus = styled.span`
  display: inline-flex;
  align-items: center;
  svg {
    width: 18px;
    height: 18px;
  }
`;
